import {AdminUserRole} from "@/models";
import {RefundStatus} from "./RefundStatus";

export * from './RefundStatus';
export * from './ChooseProductCondition';
export * from './SpotPositionCode';

export type IAppConfig = {
    version: number;
    versionCheckInterval: number;
    currentEnvironment: string;
    baseApiUrl: string;
    dataTimeToLive: number;
    baseFolder: string;
    googleMapApiKey: string;
    urlGeneral: string;
    imageStorageUrl: string;
    noTranslate: boolean;
    productImageStorageUrl: string;
    auth: {
        microsoft: {
            clientId: string;
            tenantId: string;
        };
        [key: string]: any
    }
}

const APP_CONFIG_VALUE: IAppConfig = (window as any).APP_CONFIG || {
    currentEnvironment: 'Production',
    baseApiUrl: 'http://localhost:7000/admin',
    baseFolder: '/',
    imageStorageUrl: '',
    urlGeneral: '',
} as IAppConfig;


export const registerConfig =
    (app: IModule) => {
        app.constant('APP_CONFIG', APP_CONFIG_VALUE);
        app.constant('RefundStatus', RefundStatus);
        app.constant('AdminUserRole', AdminUserRole);
    }
